import React from 'react';
import Button from '../common/Button';

/**
 * Generic confirm dialog on the shared modal chrome (.modal-backdrop /
 * .modal in styles/tailwind.css — the same chrome DeleteConfirmationPopup
 * uses). The Coord replacement for window.confirm(): copy comes from the
 * caller so the message can depend on state, e.g. whether any paid access
 * remains after cancelling a subscription.
 *
 *   busy  — the confirmed action is running: both buttons disabled, the
 *           confirm button shows its spinner, backdrop click is ignored.
 *   error — inline failure line (role="alert") so the caller never needs
 *           window.alert(); the dialog stays open for a retry or close.
 */
export default function ConfirmPopup({
  title,
  message,
  confirmLabel,
  cancelLabel,
  onConfirm,
  onCancel,
  busy = false,
  error = null,
  variant = 'danger'
}) {
  return (
    <div
      className="modal-backdrop"
      onClick={busy ? undefined : onCancel}
      role="dialog"
      aria-modal="true"
      aria-labelledby="confirm-dialog-title"
    >
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <div className="p-6">
          <h2
            id="confirm-dialog-title"
            className="font-display text-xl font-semibold mb-3 text-text-primary"
          >
            {title}
          </h2>
          <p className="mb-6 text-text-secondary">{message}</p>
          {error && (
            <p className="mb-4 text-sm text-error-700" role="alert">{error}</p>
          )}
          <div className="flex justify-end gap-3">
            <Button variant="tertiary" size="md" onClick={onCancel} disabled={busy}>
              {cancelLabel}
            </Button>
            <Button variant={variant} size="md" onClick={onConfirm} loading={busy}>
              {confirmLabel}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
